import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Nav, Form, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { PortfolioServiceApi, Configuration } from "../../../services/portfolio";
import { APIControl } from '../../../helpers/APIControl';
import { useSelector } from 'react-redux';
import NumberFormatter from '../../../formatters/NumberFormatter';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { tr } from 'date-fns/locale';
import SearchPortfoy from '../../../components/search/searchPortfoy';

const AddTransactionModal = ({ show, handleClose, onTransactionAdd, updateMode = false, transaction = {} }) => {
    const { t } = useTranslation();
    const portfolioServiceApi = new PortfolioServiceApi(
        new Configuration({ basePath: process.env.REACT_APP_PORTFOLIO_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_PORTFOLIO_API_BASE_PATH)
    );
    const [activeTab, setActiveTab] = useState('stock');
    const [selectedSecurity, setSelectedSecurity] = useState();
    const [defaultSecurity, setDefaultSecurity] = useState();
    const [quantity, setQuantity] = useState("");
    const [tradeType, setTradeType] = useState("buy");
    const [price, setPrice] = useState("");
    const [amount, setAmount] = useState(""); 
    const [currencyAmount, setCurrencyAmount] = useState(""); 
    const [currencyRate, setCurrencyRate] = useState("");
    const [commission, setCommission] = useState("");
    const [totalAmount, setTotalAmount] = useState("0");
    const [description, setDescription] = useState("");
    const token = useSelector((state) => state.auth?.token);
    const selectedPortfolioId = useSelector((state) => state.portfolio.selectedPortfolioId);
    const numberFormatter = new NumberFormatter();
    const toast = useRef(null);
    const FX_RATE_SCALE = 10_000;
    const numberFormatter2 = new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const [errors, setErrors] = useState({
        selectedSecurity: false,
        quantity: false,
        price: false,
        amount: false,
        currencyAmount: false,
        currencyRate: false, // Add error field for currency rate
    });
    const [isLoading, setIsLoading] = useState(false);
    // // Reset form when tab changes
    // useEffect(() => {
    //     if (activeTab === 'cash') {
    //         setQuantity("1"); // Fixed at 1 for cash
    //         setCommission(""); // Not applicable for cash
    //         setPrice("");
    //         setAmount("");
    //         setSelectedSecurity(null);
    //         setDefaultSecurity(null); // Already clearing for cash tab
    //         setCurrencyAmount("");
    //         setCurrencyRate(""); // Reset currency rate
    //     } else if (activeTab === 'currency') {
    //         setQuantity("1"); // Fixed at 1 for currency
    //         setCommission(""); // Not applicable for currency
    //         setPrice("");
    //         setAmount("");
    //         setCurrencyAmount("");
    //         setCurrencyRate(""); // Reset currency rate
    //         setSelectedSecurity(null); // Clear selected security
    //         setDefaultSecurity(""); // Clear search input for currency tab
    //     } else {
    //         setQuantity("");
    //         setPrice("");
    //         setAmount("");
    //         setCurrencyAmount("");
    //         setCurrencyRate(""); // Reset currency rate
    //         setSelectedSecurity(null); // Clear selected security
    //         setDefaultSecurity(""); // Clear search input for other tabs
    //     }

    //     setTotalAmount("0");
    //     setErrors({
    //         selectedSecurity: false,
    //         quantity: false,
    //         price: false,
    //         amount: false,
    //         currencyAmount: false,
    //         currencyRate: false, // Add error field for currency rate
    //     });
    // }, [activeTab]);

    useEffect(() => {
        resetForm();
        if (!updateMode || !transaction) return;
        
        let tab = detectTab(transaction);
        setActiveTab(tab);
        setTradeType(transaction.nominal < 0 ? 'sell' : 'buy');
        setCommission(numberFormatter.Double(transaction.commissionRate ?? 0, 4));
        console.log('commision: ',commission);

        setDescription(transaction.description ?? '');
        setSelectedSecurity({ id: transaction.entityId });
        setDefaultSecurity(transaction.entityCode);

        if (tab === 'cur.1') {
            const amountValue = Math.abs(transaction.nominal); 
            setAmount(amountValue);                         
            setTotalAmount(amountValue);   
            
            return;                                           
        }
        if (tab === 'stock' || tab === 'fund') {
            const dec = tab === 'fund' ? 6 : 2;
            setPrice(numberFormatter.Double(Math.abs(transaction.price), dec));
            setQuantity(numberFormatter.Double(Math.abs(transaction.nominal), 0));
            
            const total = Math.abs(transaction.price * transaction.nominal * (1 + (parseFloat(transaction.commissionRate) || 0)));
            setTotalAmount(numberFormatter.Double(total, 2));
        }  else if (tab === 'currency') {
            setCurrencyAmount((Math.abs(transaction.nominal)));
            setCurrencyRate(transaction.price);
            setTotalAmount(numberFormatter.Double(transaction.price * Math.abs(transaction.nominal), 2));
       }  else {
            const qtyValue = Math.abs(transaction.nominal);
            const priceValue = Math.abs(transaction.price);
            setPrice(numberFormatter.Double(Math.abs(transaction.price), 2));
            setQuantity(numberFormatter.Double(Math.abs(transaction.nominal), 0));
                
            setTotalAmount(numberFormatter.DoubleMath.abs(transaction.price * transaction.nominal * (1 + (parseFloat(transaction.commissionRate) || 0))));
    }
        
        }, [updateMode, transaction, show]);

    useEffect(() => {
      if (activeTab === "cur.1" || activeTab === "currency") return;

      if (!price || !quantity) { setTotalAmount("0"); return; }

      const priceNumeric =
          typeof price === "number"
            ? price
            : parseFloat(
                parseFloat(price.toString().replace(/,/g, "").replace(/^$/, "0"))
              );
          

        const quantityNumeric =
          typeof quantity === "number"
            ? quantity
            : parseInt(
                quantity.toString().replace(/[^0-9]/g, "").replace(/^$/, "0"),
                10
            );
          

        let commissionRate = 0;
        if (commission !== null && commission !== undefined && commission !== "") {
        const comRaw = commission
            .toString()               
            .replace("%", "")
            .replace(",", ".")
            .replace(/[^0-9.]/g, "");
        commissionRate = (parseFloat(comRaw) || 0);
        }

        const totalNumeric = priceNumeric * quantityNumeric * (1 + commissionRate);
    
        const formattedTotal = numberFormatter.Double(totalNumeric, 2);
    
        setTotalAmount(formattedTotal);
    }, [price, quantity, commission, activeTab]);

    useEffect(() => {
        if (activeTab === "currency") {
          calculateCurrencyTotalAmount(currencyAmount, currencyRate);
        }
    }, [currencyAmount, currencyRate, activeTab]);

    useEffect(() => {
      if (updateMode && transaction && activeTab === 'currency') {
        const amountNum = parseFloat(transaction.nominal);
        const rateNum = parseFloat(transaction.price);
        const total = Math.abs(amountNum) * rateNum;
        setTotalAmount(numberFormatter.Double(total, 2));
      }
    }, [updateMode, transaction, activeTab]);


    const selectedSearchItem = (e) => {
        setSelectedSecurity(e.document);
        setDefaultSecurity(e.document.name);
        setErrors((prev) => ({ ...prev, selectedSecurity: false }));
    };

    const detectTab = (tx) => {
        if (tx.entityId === 'cur.1')               return 'cur.1';
        if (tx.entityUniqueCode?.includes(':FX') || tx.entityUniqueCode?.includes(':X5') ) return 'currency';
        if (tx.entityUniqueCode?.includes(':TMF'))return 'fund';
        return 'stock';
    };

    const handleQuantityChange = (e) => {
        if (activeTab === 'cur.1') return; 

        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, "");

        if (inputValue === "") {
            setQuantity("");
            return;
        }

        const formattedValue = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        setQuantity(formattedValue);
        //calculateTotalAmount(price, inputValue); 
    };
    // Add handler for currency amount
    const handleCurrencyAmountChange = (e) => {
        let inputValue = e.target.value;

        // Remove formatting and get only numbers
        
        inputValue = inputValue.replace(/\D/g, "");

        // Check for empty input
        if (inputValue === "") {
            setCurrencyAmount("");
            setTotalAmount("0");
            return;
        }

        // Format number with thousands separator
        const formattedValue = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        setCurrencyAmount(formattedValue);
        setErrors((prev) => ({ ...prev, currencyAmount: false }));
    };
    const handleCurrencyRateChange = (e) => {
         let v = e.target.value
           .replace(/[^0-9.,]/g, "")   
           .replace(/,/g, ".");        

        v = v.replace(/(\..*?)\./g, "$1");

        const [i, d] = v.split(".");
        v = d !== undefined ? `${i}.${d.slice(0, 2)}` : i;

        setCurrencyRate(v);

    };
    const handlePriceChange = (e) => {
        let v = e.target.value
           .replace(/[^0-9.,]/g, "")   
           .replace(/,/g, ".");        

        v = v.replace(/(\..*?)\./g, "$1");

        const [i, d] = v.split(".");
        v = d !== undefined ? `${i}.${d.slice(0, 2)}` : i;

        setPrice(v);

        // if (activeTab === 'currency') {
        //     calculateCurrencyTotalAmount(currencyAmount, v);
        // } else {
        //     //calculateTotalAmount(Number(v || 0), quantity);
        // }
    };
    const formatPriceOnBlur = () => {
        if (price === "") return;
          setPrice(numberFormatter.Double(Number(price), 2));
        };
    const handleAmountChange = (e) => {
        let inputValue = e.target.value;

        // Mevcut formatlamayı kaldır ve yalnızca sayıyı al
        inputValue = inputValue.replace(/\./g, "").replace(/,/g, "");

        // Boş giriş için kontrol
        if (inputValue === "") {
            setAmount("");
            setTotalAmount("0");
            return;
        }

        // Sayıyı manuel olarak üçlü gruplandırarak formatla
        const formattedValue = inputValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        setAmount(formattedValue);
        setErrors((prev) => ({ ...prev, amount: false }));

        // Cash işlemleri için toplam tutar doğrudan miktarı gösterir (adet sabit 1)
        const sanitizedAmount = parseInt(inputValue) || 0;
        setTotalAmount(new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 0 }).format(sanitizedAmount));
    };
   const handleCommissionChange = (e) => {
      if (activeTab === "cur.1" || activeTab === "currency") return;

      let v = e.target.value
                .replace(/[^0-9.,]/g, "")  
                .replace(/,/g, ".")       
                .replace(/(\..*?)\./g, "$1");

      const [i, d] = v.split(".");
      v = d !== undefined ? `${i}.${d.slice(0, 4)}` : i;  

      setCommission(v);
      //calculateTotalAmount(price, quantity);              
    };
    const formatCommissionOnBlur = () => {
      if (commission === "") return;
      const num = parseFloat(commission);
      setCommission(numberFormatter.Double(num, 2));       
    };
    // const calculateTotalAmount = (priceInput, quantityInput) => {
    //     const priceNumeric =
    //       typeof priceInput === "number"
    //         ? priceInput
    //         : parseFloat(
    //             parseFloat(priceInput.toString().replace(/,/g, "").replace(/^$/, "0"))
    //           );
          

    //     const quantityNumeric =
    //       typeof quantityInput === "number"
    //         ? quantityInput
    //         : parseInt(
    //             quantityInput.toString().replace(/[^0-9]/g, "").replace(/^$/, "0"),
    //             10
    //         );
          

    //     let commissionRate = 0;
    //     if (commission !== null && commission !== undefined && commission !== "") {
    //     const comRaw = commission
    //         .toString()               
    //         .replace("%", "")
    //         .replace(",", ".")
    //         .replace(/[^0-9.]/g, "");
    //     commissionRate = (parseFloat(comRaw) || 0) / 100;
    //     }
    
    //     const totalNumeric = priceNumeric * quantityNumeric * (1 + commissionRate);
    
    //     const formattedTotal = numberFormatter.Double(totalNumeric, 2);
    
    //     setTotalAmount(formattedTotal);
    // };

    const calculateCurrencyTotalAmount = (amount, rate) => {
        //setTotalAmount(numberFormatter.Double(currencyAmount * Math.abs(currencyRate), 2)); 
       const toNumber = (v) =>
        parseFloat(String(v).replace(/\./g, "").replace(/,/g, ".")) || 0;

        const total = amount * rate;
        setTotalAmount(numberFormatter.Double(total, 2));
    };

    const handleTransactionActionClick = () => {
        if (activeTab === 'cur.1') {
            if (!amount) {
                setErrors(prev => ({ ...prev, amount: true }));
                return;
            }

            const sanitizedAmount = typeof amount === "string" ? parseInt(amount) || 0 : amount || 0;
            const transactionAmount = tradeType === "sell"
                ? -Math.abs(sanitizedAmount)
                : Math.abs(sanitizedAmount);    
            setIsLoading(true);

            if (updateMode) {
                updateCashTransaction(transactionAmount);
            } else {
                addCashTransaction(transactionAmount);
            }
        } else if (activeTab === 'currency') {
            if (!selectedSecurity) {
                setErrors(prev => ({ ...prev, selectedSecurity: true }));
                return;
            }

            if (!currencyAmount) {
                setErrors(prev => ({ ...prev, currencyAmount: true }));
                return;
            }

            if (!currencyRate) {
                setErrors(prev => ({ ...prev, currencyRate: true }));
                return;
            }

            const sanitizedAmount = typeof currencyAmount === "string" ?
                parseFloat(currencyAmount.replace(/\./g, "").replace(/,/g, ".")) || 0 :
                currencyAmount || 0;

            const sanitizedRate = typeof currencyRate === "string"
               ? parseFloat(
                   currencyRate
                     .replace(/[^0-9.,]/g, "")   
                     .replace(",", ".")       
                 ) || 0
               : currencyRate || 0;

            setIsLoading(true);
            if (updateMode) {
                updateCurrencyTransaction(sanitizedRate, sanitizedAmount);   
            } else {
                addCurrencyTransaction(sanitizedAmount, sanitizedRate);
            }
        } else {
            // Regular transaction validation
            const hasErrors = {
                selectedSecurity: !selectedSecurity,
                quantity: !quantity,
                price: !price,
            };
            if (Object.values(hasErrors).some((error) => error)) {
                setErrors(hasErrors);
                return;
            }

            const sanitizedQuantity = typeof quantity === "string" ? parseInt(quantity.replace(/\./g, "").replace(/\,/g, "")) || 0 : quantity || 0;

            setIsLoading(true);
            if (updateMode) {
                updateTransaction(price, sanitizedQuantity);
            } else {
                addTransaction(price, sanitizedQuantity);
            }
        }
    };

    // Helper function to convert date to YYYYMMDD integer format
    const convertDateToYYYYMMDD = (date = new Date()) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return parseInt(`${year}${month}${day}`);  // Returns as integer, e.g., 20231218
    };

    // New function to handle cash transactions
    const addCashTransaction = async (sanitizedAmount) => {
        try {
            // Apply sign based on the transaction type
            const transactionAmount = tradeType === "sell" ? -Math.abs(sanitizedAmount) : sanitizedAmount;

            const requestBody = {
                portfolioId: selectedPortfolioId,
                transactions: [
                    {
                        entityId: "cur.1", // Special entityId for cash transactions
                        date: convertDateToYYYYMMDD(),
                        nominal: transactionAmount, // Fixed at 1 for cash transactions
                        price: 1, // Use the amount as the price
                        commissionRate: 0, // No commission for cash transactions
                        description: description
                    }
                ]
            };

            const response = await portfolioServiceApi.v1TransactionAddPost(token, requestBody);
            if (response.data) {
                onTransactionAdd(response.data);
                closeAndResetForm();
            } else {
                console.error("İşlem ekleme sırasında bir hata oluştu:", response);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.current.show({ severity: 'error', summary: 'Hata', detail: errorMessage, life: 3000 });
            console.error("İşlem ekleme hatası:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateCashTransaction = async (sanitizedAmount) => {
        try {
            const transactionAmount =
                tradeType === "sell" ? -Math.abs(sanitizedAmount) : sanitizedAmount;

            const requestBody = {
                transactionId: transaction.id,
                portfolioId:   selectedPortfolioId,
                entityId:      "cur.1",               
                date:          convertDateToYYYYMMDD(),
                nominal:       transactionAmount,     
                price:         1,                     
                commissionRate: 0,
                description,
            };

            const response =
                await portfolioServiceApi.v1TransactionUpdatePost(token, requestBody);

            if (response.data) {
                onTransactionAdd(response.data);      
                closeAndResetForm();                 
            } else {
                console.error("Nakit güncelleme hatası:", response);
            }
        } catch (err) {
            const msg = err?.response?.data?.message ||
                        "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.current.show({
                severity: "error",
                summary:  "Hata",
                detail:   msg,
                life:     3000,
            });
        } finally {
            setIsLoading(false);                      // spinnerı durdur
        }
    };

    // Update addCurrencyTransaction function to use currencyRate
    const addCurrencyTransaction = async (sanitizedAmount, sanitizedRate) => {
        try {
            // Apply sign based on the transaction type (buy = positive, sell = negative)
            const transactionAmount = tradeType === "sell" ? -Math.abs(sanitizedAmount) : sanitizedAmount;

            const requestBody = {
                portfolioId: selectedPortfolioId,
                transactions: [
                    {
                        entityId: selectedSecurity?.id,
                        date: convertDateToYYYYMMDD(),
                        nominal: transactionAmount,
                        price: sanitizedRate, 
                        currencyAmount: transactionAmount, 
                        commissionRate: 0, 
                        description: description
                    }
                ]
            };

            const response = await portfolioServiceApi.v1TransactionAddPost(token, requestBody);
            if (response.data) {
                onTransactionAdd(response.data);
                closeAndResetForm();
            } else {
                console.error("İşlem ekleme sırasında bir hata oluştu:", response);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.current.show({ severity: 'error', summary: 'Hata', detail: errorMessage, life: 3000 });
            console.error("İşlem ekleme hatası:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const addTransaction = async (sanitizedPrice, sanitizedQuantity) => {
        try {

            const transactionPrice = Math.abs((sanitizedPrice))


            var outNominal = tradeType === "sell" 
                ? -Math.abs((sanitizedQuantity))
                : (sanitizedQuantity);

            const sanitizedCommission = typeof commission === "string" ? parseFloat(commission.replace("%", "").replace(",", ".")) || 0 : 0;

            const requestBody = {
                portfolioId: selectedPortfolioId,
                transactions: [
                    {
                        entityId: selectedSecurity?.id,
                        date: convertDateToYYYYMMDD(), // Changed to YYYYMMDD format
                        nominal: outNominal,
                        price: transactionPrice,
                        commissionRate: sanitizedCommission,
                        description: description
                    }
                ]
            };

            const response = await portfolioServiceApi.v1TransactionAddPost(token, requestBody);
            if (response.data) {
                onTransactionAdd(response.data);
                closeAndResetForm();
            } else {
                console.error("İşlem ekleme sırasında bir hata oluştu:", response);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.current.show({ severity: 'error', summary: 'Hata', detail: errorMessage, life: 3000 });
            console.error("İşlem ekleme hatası:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateTransaction = async (sanitizedPrice, sanitizedQuantity) => {
        try {
            // Fix price parsing for API request - correctly handle Turkish number format
            const priceNumber = parseFloat(
               sanitizedPrice
                 .toString()
                 .replace(/,/g, "")        
             );   
             const transactionPrice = tradeType === "sell" ? Math.abs(priceNumber) : priceNumber;
            // const transactionPrice = tradeType === "sell"
            //     ? -Math.abs(parseFloat(sanitizedPrice.replace(/\./g, "").replace(",", ".")))
            //     : parseFloat(sanitizedPrice.replace(/\./g, "").replace(",", "."));

            // Parse commission rate - we send the raw rate to the API (e.g., 0.1 for 0.1%)
           const sanitizedCommission =
               parseFloat(
                 commission
                   .toString()         
                   .replace("%", "")
                   .replace(",", ".")
            ) || 0;
            let outNominal =
               tradeType === "sell"
                 ? -Math.abs(sanitizedQuantity)
                 :  Math.abs(sanitizedQuantity);
            const requestBody = {
                transactionId: transaction.id,
                portfolioId: selectedPortfolioId,
                entityId: selectedSecurity?.id,
                date: convertDateToYYYYMMDD(), // Changed to YYYYMMDD format
                nominal: outNominal,
                price : transactionPrice,
                commissionRate: sanitizedCommission,
                description: description
            };

            console.log("Update Request Body:", requestBody); // Güncelleme API isteğini kontrol et

            const response = await portfolioServiceApi.v1TransactionUpdatePost(token, requestBody);

            if (response.data) {
                console.log("Update Successful:", response.data); // Başarılı yanıtı kontrol et
                onTransactionAdd(response.data); // Güncellenmiş veriyi işle
                closeAndResetForm(); // Formu kapat ve sıfırla
            } else {
                console.error("İşlem güncelleme sırasında bir hata oluştu:", response);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
            toast.current.show({ severity: 'error', summary: 'Hata', detail: errorMessage, life: 3000 });
            console.error("İşlem güncelleme hatası:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const updateCurrencyTransaction = async (rate, amount) => {
            try {
                const transactionAmount =
                    tradeType === "sell" ? -Math.abs(amount) : amount;

                const requestBody = {
                    transactionId: transaction.id,
                    portfolioId:   selectedPortfolioId,
                    entityId:      selectedSecurity.id,
                    date:          convertDateToYYYYMMDD(),
                    nominal:       transactionAmount,
                    price:         rate,           
                    commissionRate: 0,
                    description,
                };
            
                const response =
                    await portfolioServiceApi.v1TransactionUpdatePost(token, requestBody);
            
                if (response.data) {
                    onTransactionAdd(response.data); 
                    closeAndResetForm();              
                } else {
                    console.error("İşlem güncelleme hatası:", response);
                }
            } catch (err) {
                const msg =
                    err?.response?.data?.message ||
                    "Bir hata oluştu. Lütfen tekrar deneyin.";
                toast.current.show({
                    severity: "error",
                    summary:  "Hata",
                    detail:   msg,
                    life:     3000,
                });
            } finally {
                setIsLoading(false); 
            }
    };      

    const resetForm = () => {
        setSelectedSecurity(null);
        setDefaultSecurity("");
        setQuantity("");
        setTradeType("buy");
        setPrice("");
        setAmount("");
        setCurrencyAmount("");
        setCurrencyRate(""); // Reset currency rate
        setCommission("");
        setTotalAmount("0");
        setDescription("");
        setErrors({
            selectedSecurity: false,
            quantity: false,
            price: false,
            amount: false,
            currencyAmount: false,
            currencyRate: false, // Add error field for currency rate
        });
    };

    const closeAndResetForm = () => {
        resetForm();
        handleClose();
    };

    // Add a new function to update error message labels based on trade type
    const getErrorMessage = (fieldName) => {
        if (fieldName === 'currencyAmount') {
            return tradeType === "sell" ?
                "Çıkış yapılacak miktar boş bırakılamaz." :
                "Giriş yapılacak miktar boş bırakılamaz.";
        }
        if (fieldName === 'currencyRate') {
            return tradeType === "sell" ?
                "Satış fiyatı boş bırakılamaz." :
                "Alış fiyatı boş bırakılamaz.";
        }
        return "Bu alan boş bırakılamaz.";
    };

    return (
        <>
            <Toast ref={toast} />

            <Modal show={show} onHide={closeAndResetForm} centered className="add-transaction-modal">
                <Modal.Header>
                    <Modal.Title className="modalTitle">{updateMode ? t('portfolio.update') : t('portfolio.add')}</Modal.Title>
                    <FontAwesomeIcon
                        icon={faCircleXmark}
                        onClick={closeAndResetForm}
                        className="custom-close-icon"
                    />
                </Modal.Header>
                <Modal.Body>
                    <div className="segment-container">
                        <Nav fill variant="tabs" activeKey={activeTab} onSelect={(selectedTab) => {
                            // Force clear search input when changing tabs by explicitly setting defaultSecurity to empty
                            if (updateMode) return;
                            setDefaultSecurity("");
                            // Set the active tab after a slight delay to ensure defaultSecurity change is processed
                            setTimeout(() => {
                                setActiveTab(selectedTab);
                            }, 10);
                        }} className="transaction-segment">
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="stock" className="segment-link" disabled={updateMode && activeTab !== 'stock'} >Hisse</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="fund" className="segment-link" disabled={updateMode && activeTab !== 'fund'}>Fon</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="currency" className="segment-link"  disabled={updateMode && activeTab !== 'currency'}>Döviz</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="cur.1" className="segment-link" disabled={updateMode && activeTab !== 'cur.1'}>Nakit</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="active-indicator" style={{ left: `${['stock', 'fund', 'currency', 'cur.1'].indexOf(activeTab) * 25}%` }} />
                    </div>

                    {/* show search for all tabs except cash */}
                    {activeTab !== 'cur.1' && (
                        <div className="searchContainer">
                            <SearchPortfoy
                                inputValue={defaultSecurity}
                                selectedSearchItem={selectedSearchItem}
                                key={`search-${activeTab}`}
                                filterByClass={
                                    activeTab === 'fund'     ? 'Fund'     :
                                    activeTab === 'currency' ? 'Currency' :
                                    activeTab === 'stock' ? 'Equity' :
                                    undefined  
                                }
                            />
                            {errors.selectedSecurity && <Alert className='alert' variant="danger">{t('portfolio.selectSymbol')}</Alert>}
                        </div>
                    )}
                    {activeTab !== 'cur.1' && activeTab !== 'currency' &&(
                    <div className='inputContainer'>
                        <label className='inputLabelStar'>{activeTab === 'currency' ? 'Fiyat' : 'Adet'}</label>
                        {/* <Form.Control
                            type="text"
                            placeholder={'Adet'}
                            value={quantity}
                            onChange={handleQuantityChange}
                            className={`quantity-input`}
                            // readOnly={activeTab === 'cash'}
                            // style={activeTab === 'cash' ? { backgroundColor: '#e9ecef', color: '#6c757d' } : {}}
                        /> */}
                             <NumericFormat
                              customInput={Form.Control} 
                              value={quantity}       
                              thousandSeparator=","  
                              decimalSeparator="."     
                              allowNegative={false}
                              allowLeadingZeros={false}
                              decimalScale={0} 
                              fixedDecimalScale={false} 
                              onValueChange={({ value }) => setQuantity(value)}
                              className="quantity-input"
                            />
                        {!activeTab === 'cur.1' && !activeTab === 'currency' && errors.quantity &&
                            <Alert variant="danger">Adet alanı boş bırakılamaz.</Alert>}
                        {activeTab === 'currency' && errors.price &&
                            <Alert variant="danger">Fiyat alanı boş bırakılamaz.</Alert>}
                    </div>
                    )}
                    { activeTab !== 'cur.1' &&  activeTab !== 'currency' &&(
                    <div className="trade-type-container">
                        <Nav fill variant="tabs" activeKey={tradeType} onSelect={(selectedType) => setTradeType(selectedType)} className="trade-segment">
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="buy" className="trade-link">{t('portfolio.buy')}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="sell" className="trade-link">{t('portfolio.sell')}</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    )}
                

                    {activeTab === 'cur.1' ? (
                        <div className='inputContainer'>
                            <label className='inputLabelStar'>Miktar</label>
                            {/* <Form.Control
                                type="text"
                                placeholder=""
                                value={amount}
                                onChange={handleAmountChange}
                                className="amount-input"
                            /> */}
                            <NumericFormat
                              customInput={Form.Control} 
                              value={amount}       
                              thousandSeparator=","  
                              decimalSeparator="."     
                              allowNegative={false}
                              allowLeadingZeros={false}
                              decimalScale={2} 
                              fixedDecimalScale={false} 
                              onValueChange={({ value }) => setAmount(value)}
                              className="amount-input"
                            />
                            {errors.amount && <Alert variant="danger">Miktar alanı boş bırakılamaz.</Alert>}
                        </div>
                          
                    ) : activeTab === 'currency' ? (
                        <>
                            <div className='inputContainer'>
                                <label className='inputLabelStar'>Miktar</label>
                                {/* <Form.Control
                                    type="text"
                                    placeholder=""
                                    value={currencyAmount}
                                    onChange={handleCurrencyAmountChange}
                                    className="amount-input"
                                /> */}
                                  <NumericFormat
                                      customInput={Form.Control} 
                                      value={currencyAmount}       
                                      thousandSeparator=","  
                                      decimalSeparator="."     
                                      allowNegative={false}
                                      allowLeadingZeros={false}
                                      decimalScale={0} 
                                      fixedDecimalScale={false} 
                                      onValueChange={({ value }) => setCurrencyAmount(value)}
                                      className="amount-input"
                                />
                                {errors.currencyAmount &&
                                    <Alert variant="danger">{getErrorMessage('currencyAmount')}</Alert>}
                            </div>
                            <div className="trade-type-container" style={{marginTop : '6px'}}>
                                <Nav fill variant="tabs" activeKey={tradeType} onSelect={(selectedType) => setTradeType(selectedType)} className="trade-segment">
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey="buy" className="trade-link">{t('portfolio.buy')}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey="sell" className="trade-link">{t('portfolio.sell')}</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                            <div className='inputContainer'>
                                <label className='inputLabelStar'>
                                    {tradeType === "sell" ? "Satış Fiyatı" : "Alış Fiyatı"}
                                </label>
                                {/* <Form.Control
                                    type="text"
                                    placeholder=""
                                    value={currencyRate}
                                    onChange={handleCurrencyRateChange}
                                    className="price-input"
                                /> */}
                                  <NumericFormat
                                      customInput={Form.Control} 
                                      value={currencyRate}       
                                      thousandSeparator=","  
                                      decimalSeparator="."     
                                      allowNegative={false}
                                      allowLeadingZeros={false}
                                      decimalScale={4} 
                                      fixedDecimalScale={false} 
                                      onValueChange={({ value }) => setCurrencyRate(value)}
                                      className="price-input"
                                />
                                {errors.currencyRate &&
                                    <Alert variant="danger">{getErrorMessage('currencyRate')}</Alert>}
                            </div>
                        </>
                    ) : (
                        <div className='inputContainer'>
                            <label className='inputLabelStar'>Fiyat</label>
                            {/* <Form.Control
                                type="text"
                                placeholder=""
                                value={price}
                                onChange={handlePriceChange}
                                onBlur={formatPriceOnBlur}
                                className="price-input"
                            /> */}
                            <NumericFormat
                              customInput={Form.Control}   
                              value={price}                     
                              thousandSeparator=","            
                              decimalSeparator="."             
                              decimalScale={activeTab === 'fund' ? 6 : 2}                 
                              fixedDecimalScale={false}       
                              allowNegative={false}
                              allowLeadingZeros={false}
                              onValueChange={({ value }) => setPrice(value)}  
                              className="price-input"
                            />
                            {errors.price && <Alert variant="danger">Fiyat alanı boş bırakılamaz.</Alert>}
                        </div>
                    )}

                    { activeTab === 'cur.1' &&(
                    <div className="trade-type-container" style={{marginTop : '4px'}}>
                        <Nav fill variant="tabs" activeKey={tradeType} onSelect={(selectedType) => setTradeType(selectedType)} className="trade-segment">
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="buy" className="trade-link">{t('portfolio.entry')}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className='navItem'>
                                <Nav.Link eventKey="sell" className="trade-link">{t('portfolio.exit')}</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                        )
                    }

                    <div className='inputContainer'>
                        <label className='inputLabel'>Komisyon</label>
                        {/* <Form.Control
                            type="text"
                            //placeholder="%"
                            value={activeTab === 'cur.1' || activeTab === 'currency' ? "" : commission}
                            onChange={handleCommissionChange}
                            onBlur={formatCommissionOnBlur}
                            className="commission-input"
                            readOnly={activeTab === 'cur.1' || activeTab === 'currency'}
                        /> */}
                        <NumericFormat
                              customInput={Form.Control}   
                              value={activeTab === 'cur.1' || activeTab === 'currency' ? "" : commission}                     
                              thousandSeparator=","            
                              decimalSeparator="."             
                              decimalScale={4}                 
                              fixedDecimalScale={false}       
                              allowNegative={false}
                              allowLeadingZeros={false}
                              onValueChange={({ value }) => setCommission(value)}  
                              className="price-input"
                              readOnly={activeTab === 'cur.1' || activeTab === 'currency'}
                            />
                    </div>

                    <div className='inputContainer'>
                        <label className='inputLabel'>Toplam Tutar</label>
                        { activeTab === 'cur.1' ? (
                            <NumericFormat
                                value={Math.abs(Number(amount))}
                                customInput={Form.Control}     
                                readOnly                      
                                thousandSeparator=","          
                                decimalSeparator="."  
                                decimalScale={2}
                                fixedDecimalScale={activeTab !== 'cur.1'} 
                                className="total-amount-input"
                                />
                        ) : (
                            <NumericFormat
                                value={totalAmount}
                                customInput={Form.Control}     
                                readOnly                      
                                thousandSeparator=","          
                                decimalSeparator="."  
                                decimalScale={2}
                                fixedDecimalScale={activeTab !== 'cur.1'} 
                                className="total-amount-input"
                            />
                        )}
                    </div>

                    <div className='inputContainer'>
                        <label className='inputLabel'>Açıklama</label>
                        <Form.Control
                            as="textarea"
                            placeholder="Açıklama"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={3}
                            className="description-input"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='buttonContainer'>
                        <Button
                            variant="primary"
                            onClick={handleTransactionActionClick}
                            className='custom-button button'
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    {updateMode ? 'Güncelleniyor...' : 'Ekleniyor...'}
                                </>
                            ) : (
                                updateMode ? t('portfolio.update') : t('portfolio.add')
                            )}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddTransactionModal;
